<template>
  <span>
    <el-button
      v-if="textLoaded && fileLogData.length"
      class="userLog-btn"
      type="info"
      @click="centerDialogVisible = true">
        Logs
    </el-button>
    <div
      class="userlog-tag"
      v-for="(logs, index) in fileLogData.slice(0, 1)"
      :key="`${index}`">
      <el-tag
        size="medium"
        type="info"
        plain>
          time: {{logs.dateTime}} Name: {{logs.userName}}
      </el-tag>
    </div>

    <el-dialog
      title="User Log"
      :visible.sync="centerDialogVisible"
      :append-to-body="true"
      width="50%"
      center>
      <span>
        <el-table
          :data="fileLogData"
          style="width: 100%"
          height="250">
          <el-table-column
            fixed
            prop="dateTime"
            label="Date">
          </el-table-column>
          <el-table-column
            prop="userName"
            label="Name">
          </el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">Close</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
    };
  },
  props: ['textLoaded', 'fileLogData'],
};
</script>
